export default "__VITE_ASSET__BiKc$kzg__"